import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Tools = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 1.75C5.5 1.33579 5.83579 1 6.25 1C6.66421 1 7 1.33579 7 1.75V2H13V1.75C13 1.33579 13.3358 1 13.75 1C14.1642 1 14.5 1.33579 14.5 1.75V2H14.6875C16.2408 2 17.5 3.27918 17.5 4.85712V5H2.5V4.85712C2.5 3.27918 3.7592 2 5.3125 2H5.5V1.75ZM2.5 14.9762C2.5 16.5541 3.7592 17.8333 5.3125 17.8333H14.6875C16.2408 17.8333 17.5 16.5541 17.5 14.9762L17.5 6H2.5V14.9762ZM4.5 8.5C4.5 7.94772 4.94772 7.5 5.5 7.5C6.05228 7.5 6.5 7.94772 6.5 8.5C6.5 9.05229 6.05228 9.5 5.5 9.5C4.94772 9.5 4.5 9.05229 4.5 8.5ZM7.5 11.5C7.5 10.9477 7.94772 10.5 8.5 10.5C9.05228 10.5 9.5 10.9477 9.5 11.5C9.5 12.0523 9.05228 12.5 8.5 12.5C7.94772 12.5 7.5 12.0523 7.5 11.5ZM13.5 11.5C13.5 10.9477 13.9477 10.5 14.5 10.5C15.0523 10.5 15.5 10.9477 15.5 11.5C15.5 12.0523 15.0523 12.5 14.5 12.5C13.9477 12.5 13.5 12.0523 13.5 11.5ZM11.5 10.5C10.9477 10.5 10.5 10.9477 10.5 11.5C10.5 12.0523 10.9477 12.5 11.5 12.5C12.0523 12.5 12.5 12.0523 12.5 11.5C12.5 10.9477 12.0523 10.5 11.5 10.5ZM13.5 8.5C13.5 7.94772 13.9477 7.5 14.5 7.5C15.0523 7.5 15.5 7.94772 15.5 8.5C15.5 9.05229 15.0523 9.5 14.5 9.5C13.9477 9.5 13.5 9.05229 13.5 8.5ZM5.5 13.5C4.94772 13.5 4.5 13.9477 4.5 14.5C4.5 15.0523 4.94772 15.5 5.5 15.5C6.05228 15.5 6.5 15.0523 6.5 14.5C6.5 13.9477 6.05228 13.5 5.5 13.5Z"
        fill="url(#paint0_linear_2721_29251)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2721_29251"
          x1="10"
          y1="1"
          x2="10"
          y2="17.8333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F62F8" />
          <stop offset="1" stopColor="#1A34FD" />
        </linearGradient>
      </defs>
    </svg>
  )
})

export default Tools
